// extracted by mini-css-extract-plugin
export default {"custominput":"CustomInput_custominput__TrUDQ","custominput__title":"CustomInput_custominput__title__EtDFR","custominput__input":"CustomInput_custominput__input__P-FFv"};